import React from "react";
import { PAY_FULL_ARREARS_ROUTE } from "../IncreaseRepayments/route.constants";
import { ManageRepaymentsOption } from "../../manageRepaymentsOption";

export const PayFullArrearsOptions = ({ accountId }) => {

  return (
    <>
      <h3>How will you pay?</h3>
      <p className="payment-options-subtitle">Please select a method to make your repayment.</p>
      <ul>
        <div className="payment-options-list"><li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Direct Debit"
              subRoute={PAY_FULL_ARREARS_ROUTE.DIRECT_DEBIT}
            >
            </ManageRepaymentsOption>
          </li>
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Debit Card"
              subRoute={PAY_FULL_ARREARS_ROUTE.DEBIT_CARD}
            >
            </ManageRepaymentsOption>
          </li>
          <li>
            <ManageRepaymentsOption
              accountId={accountId}
              title="Bank Transfer"
              subRoute={PAY_FULL_ARREARS_ROUTE.BANK_TRANSFER}
            >
            </ManageRepaymentsOption>
          </li>
        </div>
      </ul>
    </>
  );
};
